var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    "data-name": "Group 3847",
    transform: "translate(-162 -204)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(162 204)",
    fill: "#2665a4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4496",
    "data-name": "Group 4496",
    transform: "translate(-48.208 1466.616) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2343",
    "data-name": "Rectangle 2343",
    width: 20,
    height: 20,
    transform: "translate(1236.616 216.208)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sort-m",
    transform: "translate(1255.093 221.657) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    "data-name": "Path 3214",
    d: "M5.4,0V13.742l2.5-2.5,1.2,1.2L5.748,15.8l.005.005-1.2,1.2L0,12.458l1.2-1.2,2.5,2.5V0Z",
    transform: "translate(0 0.352)",
    fill: "#3bb0ff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDown);
export default __webpack_public_path__ + "static/media/icon_down.ca6a39128f987e6beba1ea45a8a0f115.svg";
export { ForwardRef as ReactComponent };